import React, { useState } from 'react';
import { Package, Wand2, List, MessageSquare, Settings } from 'lucide-react';
import { RelicBatchesManager } from './RelicBatchesManager';
import { RelicCodeGenerator } from './RelicCodeGenerator';
import { RelicCodesManager } from './RelicCodesManager';
import { RelicClaimRequestsManager } from './RelicClaimRequestsManager';
import { RelicSettingsManager } from './RelicSettingsManager';

export const RelicCodesDashboard = () => {
  const [activeTab, setActiveTab] = useState('batches');

  const tabs = [
    { id: 'batches', label: 'Batches', icon: Package },
    { id: 'generator', label: 'Generator', icon: Wand2 },
    { id: 'codes', label: 'Codes', icon: List },
    { id: 'claims', label: 'Claim Requests', icon: MessageSquare },
    { id: 'settings', label: 'Settings', icon: Settings }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'batches':
        return <RelicBatchesManager />;
      case 'generator':
        return <RelicCodeGenerator />;
      case 'codes':
        return <RelicCodesManager />;
      case 'claims':
        return <RelicClaimRequestsManager />;
      case 'settings':
        return <RelicSettingsManager />;
      default:
        return <RelicBatchesManager />;
    }
  };

  return (
    <div>
      {/* Tabs */}
      <div className="border-b bg-white">
        <div className="flex space-x-1 px-6">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-orange-500 text-orange-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="font-medium">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="bg-gray-50 min-h-screen">
        {renderContent()}
      </div>
    </div>
  );
};
